import api from './api.js'

// 查询文档
export function findWordInfoList(params){
    return api.get('/resource-portal/api/v1/wordInfo/queryByGroup',params);
}

// 推荐文档
export function findWordInfoByRecommend(params){
    return api.get('/resource-portal/api/v1/wordInfo/query',params);
}

// 文档明细
export function getWordInfoByUuid(uuid){
    return api.get(`/resource-portal/api/v1/wordInfo/${uuid}`);
}

export function getInfoByWordNo(params){
    return api.get('/resource-portal/api/v1/wordInfo/getInfoByWordNo',params);
}



// WEBPACK FOOTER //
// ./src/utils/wordInfo.js